import {MakeStore, StoreObject} from "../../stem-core/src/state/Store.js";
import {field} from "./misc/StoreField.js";
import {apiConnection} from "../connection/BlinkApiConnection.js";
import {MerchantConversionStore} from "./merchant/MerchantConversionStore.js"; // Import for dependency

class ProductPurchase extends StoreObject {
    @field(Date) createdAt;
    @field(Date) finalizedAt;
    // @field(Top) status;
    @field("Merchant") merchant;
    @field("User") user;
    @field("MerchantUser") merchantUser;
    @field("MerchantConversion") conversion;
    @field("Payment") payment;
}

export const ProductPurchaseStore = MakeStore("ProductPurchase", ProductPurchase, {dependencies: ["MerchantConversionEvent"]});


export async function apiUserPurchaseProduct(request) {
    const response = await apiConnection.post("/payments/purchase_product", request);
    return ProductPurchaseStore.loadObjectFromResponse(response);
}

export async function apiUserRequestPurchaseRefund(request) {
    return apiConnection.post("/payments/request_refund", request);
}
